import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

import InfluencerModalActionsMenuItem from '../item/InfluencerModalActionsMenuItem';
import InfluencerModalActionsMenuEmpty from '../empty/InfluencerModalActionsMenuEmpty';
import InfluencerModalActionsMenuNoEligible from '../no-eligible/InfluencerModalActionsMenuNoEligible';

import { getUpdatedRecents } from 'modules/influencers/components/modals/modal-actions-menu/utils/influencer-modal-actions';

import { __t, applyTranslations } from 'utils/language';
import { dataCommonToComponent, dataGetCommonStructure } from 'utils/data/data';

import type {
  CheckboxesListItem,
  DataStructureComponent,
  InfluencerMeta,
  RecentsMetaKey,
  RecentsResourceType,
  RecentsResultEnhanced
} from 'types';

applyTranslations(require('./influencer-modal-actions-menu-items.i18n.json'));

const getPreparedResults = (
  results: Array<RecentsResultEnhanced>
): Array<DataStructureComponent> => (
  results.map(item => {
    const id = String(item.id);
    const title = item.title;
    const updatedItem = dataGetCommonStructure(id, title, id, false);

    return dataCommonToComponent(updatedItem);
  })
);

type Props = {
  metaKey: RecentsMetaKey,
  influencerMeta?: InfluencerMeta,
  resourceType: RecentsResourceType,
  items: Array<RecentsResultEnhanced>,
  activeItemId?: string | number | null,
  onItemClick: (item: RecentsResultEnhanced | undefined | null, isSelected: boolean) => void
};

const InfluencerModalActionsMenuItems = ({
  items,
  onItemClick,
  resourceType,
  metaKey,
  influencerMeta,
  activeItemId
}: Props): JSX.Element => {
  const updatedRecents = getUpdatedRecents(
    getPreparedResults(items),
    influencerMeta,
    metaKey
  );
  const hasCampaignIds = Boolean(influencerMeta?.[metaKey].brand.length);

  if (hasCampaignIds && isEmpty(updatedRecents) && resourceType === 'campaigns') {
    return (
      <InfluencerModalActionsMenuNoEligible />
    );
  }

  if (isEmpty(updatedRecents)) {
    return (
      <InfluencerModalActionsMenuEmpty
        resourceType={resourceType}
      />
    );
  }

  // active item should be first
  const sortedItems = updatedRecents.sort((a, b) => {
    const aPriority = String(activeItemId) === String(a.id) ? 1 : 0;
    const bPriority = String(activeItemId) === String(b.id) ? 1 : 0;

    if (aPriority === bPriority) {
      return 0;
    }

    return aPriority < bPriority
      ? 1
      : -1;
  });

  return (
    <div className="influencer-modal-actions-menu-items">
      <div>
        {__t(`influencer_modal_actions_menu_items.title.${resourceType}`)}
      </div>
      {
        sortedItems.map(item => (
          <InfluencerModalActionsMenuItem
            key={`influencer-modal-actions-menu-items--${item.identifier}-${item.label}`}
            item={item}
            isActive={String(activeItemId) === String(item.id)}
            onItemClick={(listItem: CheckboxesListItem) => {
              const pickedItem = items.find((entry) => String(entry.id) === String(listItem.id));
              onItemClick(pickedItem, item.isSelected);
            }}
          />
        ))
      }
    </div>
  );
};

export default InfluencerModalActionsMenuItems;
